export const LOCAL_STORAGE = {
  REMEMBERED_EMAIL: "rememberedEmail",
  PREVIEW: "preview-",
  ORDERER: "orderer-",
};
